/**
 * Statuses after which a call will not continue. The server only finalizes
 * (and sends `hangup`) for a subset of these — `rejected` in particular only
 * ever arrives as a `call_status` push, so the client must treat it as final.
 */
const TERMINAL_STATUSES = new Set([
  'completed',
  'canceled',
  'no-answer',
  'busy',
  'failed',
  'rejected',
])

export function isTerminalCallStatus(status: string | undefined): boolean {
  return !!status && TERMINAL_STATUSES.has(status)
}

export function describeCallStatus(status: string): string {
  switch (status) {
    case 'rejected':
      return 'The call was rejected'
    case 'no-answer':
      return 'No one answered'
    case 'busy':
      return 'The line was busy'
    case 'failed':
      return 'The call failed'
    case 'canceled':
      return 'The call was canceled'
    case 'completed':
      return 'Call completed'
    default:
      return `Call ${status}`
  }
}
